export enum ECaichatRoute {
  SUBSCRIBE_PAGE = 'subscribe',
  NOT_FOUND = 'not-found',
}

/** Route data reason used when a requested chat does not exist. */
export const NOT_FOUND_REASON_CHAT = 'chat';
